<script setup lang="ts">
import { computed, watch } from 'vue'

import { setLucideProps } from '@lucide/vue'
import { useRoute } from 'vue-router'

import AppNavigationProgress from '#app/components/AppNavigationProgress.vue'
import LayoutDefault from '#app/layouts/LayoutDefault.vue'
import auth0 from '#app/services/auth0'
import { token } from '#app/store/auth'
import { Toaster } from '#ui/sonner'

setLucideProps({ strokeWidth: 1.5 })

const route = useRoute()
const useDefaultLayout = computed(() => route.matched.some((record) => record.meta.requiresAuth))

watch(
  () => auth0.isAuthenticated.value,
  async (authed) => {
    if (authed) token.value = await auth0.getAccessTokenSilently()
    else token.value = null
  },
  { immediate: true },
)
</script>

<template>
  <AppNavigationProgress />
  <Suspense>
    <LayoutDefault v-if="useDefaultLayout" />
    <router-view v-else />
    <template #fallback>
      <div class="grid min-h-screen place-items-center text-sm text-muted-foreground">Loading…</div>
    </template>
  </Suspense>
  <Toaster rich-colors close-button position="top-right" />
</template>
